import { IconX } from "@tabler/icons-react";
import { useState } from "react";
import PrimaryButton from "../../../components/PrimaryButton";
import InputField from "../../../components/common/InputField";

type Props = {
  onClose: () => void;
  refetch:()=>void;
  setFilters:any
};

export default function FilterSidebar({ onClose, setFilters,refetch }: Props) {
  const [activeTab, setActiveTab] = useState("All");

  // ✅ All filter fields in a single state
  const [rawFilters, setRawFilters] = useState({
    awbNumber: "",
    seller: "",
    warehouseName: "",
    paymentType: "",
    codAmount: "",
    sameDate: "",
    entryDate: "",
    closeDate: "",
    senderCityName: "",
    receiverCityName: "",
    city: "",
    serviceType: "",
    platform: "",
    shippingCompany: "",
    shippingAwbNumber: "",
  });

  const tabs = ["All", "Details", "Date", "Location", "Order"];

  // ✅ Handle input changes dynamically
  const handleChange = (key: string, value: string) => {
    setRawFilters((prev:any) => ({ ...prev, [key]: value }));
  };

  // ✅ On apply rawFilters — format the data as array
  const handleApplyFilters = () => {
    const formattedFilters = Object.entries(rawFilters)
      .filter(([_, value]) => value.trim() !== "")
      .map(([key, value]) => ({ [key]: value }));

      setFilters(formattedFilters)
      refetch();

    // console.log("Final Filters:", formattedFilters);

    // You can send formattedFilters to API or parent component here
    onClose();
  };

  return (
    <div className="h-full w-full bg-white rounded-l-3xl flex flex-col justify-between">
      {/* Header */}
      <div>
        <div className="flex justify-between items-center p-4 border-b sticky top-0 bg-white z-10">
          <h2 className="text-lg font-semibold">Filter Settings</h2>
          <button
            onClick={onClose}
            className="bg-[#F7F6F2] rounded-full p-1 cursor-pointer"
          >
            <IconX size={24} />
          </button>
        </div>

        {/* Tabs */}
        <div className="flex gap-2 p-4 overflow-x-auto sticky top-14 bg-white">
          {tabs.map((tab) => (
            <button
              key={tab}
              onClick={() => setActiveTab(tab)}
              className={`text-xs w-full font-medium px-3 py-1.5 rounded-full border ${
                activeTab === tab
                  ? "bg-black text-white border-black"
                  : "text-[#1E1E1E] border-[#DADADA] bg-[#F7F6F2]"
              }`}
            >
              {tab}
            </button>
          ))}
        </div>

        {/* Filter Form */}
        <div className="px-6 space-y-4 pb-6">
          {(activeTab === "All" || activeTab === "Details") && (
            <>
              <h2 className="text-[#212121]/70 text-sm font-medium">Details</h2>
              <InputField
                label="AWB No. (Optional)"
                placeholder="Search AWB , Ref , 3PL AWB and Mobile Number"
                value={rawFilters.awbNumber}
                onChange={(e) => handleChange("awbNumber", e.target.value)}
              />
              <InputField
                label="Seller"
                placeholder="Amazon"
                value={rawFilters.seller}
                onChange={(e) => handleChange("seller", e.target.value)}
              />
              <InputField
                label="Warehouse"
                placeholder="Jaipur"
                value={rawFilters.warehouseName}
                onChange={(e) => handleChange("warehouseName", e.target.value)}
              />
              <InputField
                label="Payment Mode"
                placeholder="COD/ CC"
                value={rawFilters.paymentType}
                onChange={(e) => handleChange("paymentType", e.target.value)}
              />
              <InputField
                label="COD Amount"
                placeholder="0.5 SAR"
                value={rawFilters.codAmount}
                onChange={(e) => handleChange("codAmount", e.target.value)}
              />
            </>
          )}

          {(activeTab === "All" || activeTab === "Date") && (
            <>
              <h2 className="text-[#212121]/70 text-sm font-medium">Date</h2>
              <InputField
                type="date"
                label="Same Date"
                placeholder={""}
                value={rawFilters.sameDate}
                onChange={(e) => handleChange("sameDate", e.target.value)}
              />
              <InputField
                type="date"
                label="Entry Date"
                placeholder={""}
                value={rawFilters.entryDate}
                onChange={(e) => handleChange("entryDate", e.target.value)}
              />
              <InputField
                type="date"
                label="Close Date"
                placeholder={""}
                value={rawFilters.closeDate}
                onChange={(e) => handleChange("closeDate", e.target.value)}
              />
            </>
          )}
          {(activeTab === "All" || activeTab === "Location") && (
            <>
              <h2 className="text-[#212121]/70 text-sm font-medium">Location</h2>
              <InputField
                label="Origin"
                placeholder="Riyadh"
                value={rawFilters.senderCityName}
                onChange={(e) => handleChange("senderCityName", e.target.value)}
              />
              <InputField
                label="Destination"
                placeholder="Jeddah"
                value={rawFilters.receiverCityName}
                onChange={(e) => handleChange("receiverCityName", e.target.value)}
              />
              <InputField
                label="City"
                placeholder="Mecca"
                value={rawFilters.city}
                onChange={(e) => handleChange("city", e.target.value)}
              />
            </>
          )}

          {(activeTab === "All" || activeTab === "Order") && (
            <>
              <h2 className="text-[#212121]/70 text-sm font-medium">Order Info</h2>
              <InputField
                label="Order Type"
                placeholder="Standard / Express"
                value={rawFilters.serviceType}
                onChange={(e) => handleChange("serviceType", e.target.value)}
              />
              <InputField
                label="Platform"
                placeholder="Amazon / Noon"
                value={rawFilters.platform}
                onChange={(e) => handleChange("platform", e.target.value)}
              />
              <InputField
                label="Shipping Company"
                placeholder="SMSA / Aramex"
                value={rawFilters.shippingCompany}
                onChange={(e) => handleChange("shippingCompany", e.target.value)}
              />
              <InputField
                label="Shipping AWB"
                placeholder="AWB-XXXXXX"
                value={rawFilters.shippingAwbNumber}
                onChange={(e) => handleChange("shippingAwbNumber", e.target.value)}
              />
            </>
          )}
        </div>
      </div>

      {/* Footer */}
      <div className="px-6 py-2 bg-white sticky bottom-0">
        <PrimaryButton onClick={handleApplyFilters} label={"Apply Filters"} />
      </div>
    </div>
  );
}

